import { COLLISION_COLOURS, COLLISION_GROUPS } from '../../../constants/Constants';
import { GameEvents } from '../../GameEvents';
import { CollisionCollider } from '../collisions/CollisionCollider';

export class WorldPickup extends Phaser.GameObjects.Image {
  constructor(scene, layer, model) {
    super(scene, model.x, model.y, 'game_graphics');
    this.id = model.name;
    this.type = 'pickup';
    this.setSprite();
    this.setOrigin(0.5, 1);
    if (layer) layer.add(this);

    const colliderHeight = Math.max(32, this.height);
    const colliderWidth = Math.max(32, this.width);
    this._collider = new CollisionCollider(scene, {
      x: this.x - colliderWidth * 0.5,
      y: this.y - colliderHeight,
      sensor: true,
      width: colliderWidth,
      height: colliderHeight,
      gameObject: this,
      debugColour: COLLISION_COLOURS.PICKUP,
      collisionGroup: COLLISION_GROUPS.PICKUP,
      collidesWith: COLLISION_GROUPS.HERO_BODY,
    });
  }

  get collisionCollider() {
    return this._collider;
  }

  get isPickup() {
    return !this.pickedup;
  }

  setSprite() {
    const config = this.scene.game.model.getPickupConfig(this.id);
    if (!config) {
      console.warn('PICKUP NOT FOUND - please check id : ' + this.id);
      return this.destroy();
    }
    this.setFrame(config.sprite);
  }

  pickup() {
    if (this.pickedup) return;
    this.pickedup = true;
    this.scene.events.emit(GameEvents.PICKUP_ITEM, this);
    this.destroy();
  }

  destroy() {
    this._collider.destroy();
    this._collider = null;
    super.destroy();
  }
}

export class WorldPickupWeapon extends WorldPickup {
  constructor(...args) {
    super(...args);
    this.type = 'weapon';
  }

  setSprite() {
    const config = this.scene.game.model.getWeaponConfig(this.id);
    if (!config) {
      console.warn('PICKUP NOT FOUND - please check id : ' + this.id);
      return this.destroy();
    }
    const activeskin = this.scene.game.player.getActiveWeaponSkin(this.id);
    const skinconfig = config.skins.find((s) => s.skin === activeskin);
    this.setFrame(skinconfig?.sprite || config.sprite);
  }
}
